import { render, staticRenderFns } from "./faq_table.vue?vue&type=template&id=4bb9af2e&scoped=true"
import script from "./faq_table.vue?vue&type=script&lang=js"
export * from "./faq_table.vue?vue&type=script&lang=js"
import style0 from "./faq_table.vue?vue&type=style&index=0&id=4bb9af2e&prod&lang=css"
import style1 from "./faq_table.vue?vue&type=style&index=1&id=4bb9af2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9af2e",
  null
  
)

export default component.exports